import { AlertTriangle } from 'lucide-react';

/**
 * Hinweis für Benutzer, die die Firmendaten **nicht** pflegen dürfen.
 *
 * 🚨 **Rot, nicht gelb** — es hält den Betrieb auf, bis es erledigt ist; ein Blocker soll
 * aussehen wie einer.
 *
 * 🚨 Bewusst **nicht wegklickbar**: Der Betrieb kann so lange keine korrekten Belege erzeugen,
 * und an denselben Feldern hängt die Kassen-Signatur. Ein weggeklickter Hinweis wäre nach dem
 * nächsten Seitenwechsel vergessen.
 *
 * Wer das Recht „Einstellungen bearbeiten" hat, sieht diesen Hinweis nie — der wird stattdessen
 * zur Firmenmaske geführt (`Layout.tsx`). Ein Kassierer vor einem Formular, dessen
 * Speichern-Knopf 403 liefert, wäre eine Sackgasse ohne Ausweg.
 */
export function FirmendatenBanner({ fehlend }: { fehlend: string[] }) {
  return (
    <div
      role="status"
      className="flex items-start gap-3 border-b-2 border-red-300 bg-red-50 px-4 py-2.5 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/40 dark:text-red-200"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400" />
      <div>
        <span className="font-medium">Die Firmendaten Ihres Betriebs sind unvollständig.</span>{' '}
        {fehlend.length > 0 && (
          <>Es fehlt noch: {fehlend.join(', ')}. </>
        )}
        Davon hängen Rechnungen, Lieferscheine und — falls Sie mit einer Kasse arbeiten — die
        vorgeschriebene Bon-Signatur ab. Bitte wenden Sie sich an Ihre Geschäftsleitung; zum
        Ergänzen wird das Recht „Einstellungen bearbeiten" benötigt.
      </div>
    </div>
  );
}
